import React from 'react';
import PropTypes from 'prop-types';
import useClassNames from '@medflex/hooks/useClassNames';
import Button from '../Button';
import { IconSend } from '../Icons';

const SendButton = ({ disabled, className, small, loading }) => {
  const cn = useClassNames(
    () => [(disabled || loading) && 'pointer-events-none', className],
    [className],
  );

  return (
    <Button
      shape="circle"
      className={cn}
      isDisabled={disabled}
      kind="primary"
      isLoading={loading}
      type="submit"
      size={small ? 'sm' : null}
      data-component="SendButton"
    >
      <IconSend size={small ? '4' : '5'} />
    </Button>
  );
};

SendButton.propTypes = {
  disabled: PropTypes.bool,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
  small: PropTypes.bool,
  loading: PropTypes.bool,
};

SendButton.defaultProps = {
  loading: false,
  disabled: false,
  small: false,
};

export default SendButton;
